/*
 * @Description: 路由
 * @Date: 2024-11-14 13:27:10
 */
import { markRaw } from 'vue';
import { RouterTransition } from '@/components/transition';

export const route = [
  {
    path: '/main/employee-management',
    name: 'employee-management',
    component: markRaw(RouterTransition),
    redirect: '/main/employee-management/employee-management-index',
    meta: {
      title: '员工管理'
    },
    children: [
      {
        path: '/main/employee-management/employee-management-index',
        name: 'employee-management-index',
        meta: {
          title: '员工管理'
        },
        component: () => import('../views/employee-management-index/index')
      }
    ]
  }
];
